export const STUDY_DRAWER = "StudyDrawer";
export const HISTORY_DRAWER = "HistoryDrawer";
export const REPORT_DRAWER = "ReportDrawer";
export const MALICIOUS_CUTS_DRAWER = "MALICIOUS_CUTS_DRAWER";
